import './App.css';
import { Route, Routes } from 'react-router-dom';
import HomepageView from './pages/Homepage/HomepageView';
import AlarmPalsPrivacyPolicy from './privacyPolicies/AlarmPals/AlarmPalsPrivacy';
import PartyPalsPrivacy from './privacyPolicies/PartyPals/PartyPalsPrivacy';
import PalsPartyPrivacy from './privacyPolicies/PartyPals/PalsPartyPrivacy';

function App() {
  return (
    <div className="App">
      <Routes>

        <Route exact path='/' element={<HomepageView />} /> 
        <Route exact path='/alarm-pals/privacy-policy' element={<AlarmPalsPrivacyPolicy />} />
        <Route exact path='/party-pals/privacy-policy' element={<PartyPalsPrivacy />} />
        <Route exact path='/pals-party/privacy-policy' element={<PalsPartyPrivacy />} />

      </Routes>

    </div>
  );
}

export default App;
